import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { toast } from '../hooks/useToast';

// Microsoft sign-in lands here (ENG-746): the API redirects to
// /auth/callback?code=..., and the code is swapped for the usual token.
export const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const signInWithMicrosoft = useAuthStore((state) => state.signInWithMicrosoft);
  // React StrictMode runs effects twice in development; exchange once.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const code = searchParams.get('code');
    if (!code) {
      navigate('/login?sso_error=failed', { replace: true });
      return;
    }

    signInWithMicrosoft(code)
      .then(() => {
        toast.success('Welcome back!');
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        navigate('/login?sso_error=expired', { replace: true });
      });
  }, [navigate, searchParams, signInWithMicrosoft]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
        <p className="text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
